<!-- 锁单和强制锁单 -->
<template>
    <el-form ref="form" label-width="100px" style="margin:0 20px">
        <el-row>
            <el-col :xs="24" :sm="18">
                <el-form-item :label="msg('报关发件人：')">
                    <el-input v-model.trim="sender" :placeholder="msg('请输入报关发件人')" size="mini"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18">
                <el-form-item :label="msg('报关车次：')">
                    <el-input v-model.trim="checi" :placeholder="msg('请输入报关车次')" size="mini"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <div style="text-align:center; margin-top: 15px;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确认')}}</span></el-button>
            <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
        </div>

    </el-form>

</template>

<script>

export default {
    name: "declareLock",
    components:{
    },
    data(){
        return {
            sender:null,
            checi:null,
            ids:null,
            type:null,
        }
    },
    mounted(){
    },
    props:{
    },
    methods:{
        init(type,ids){
            this.sender = null;
            this.checi = null;
            this.ids = ids;
            this.type = type;
        },
        onSubmit(){

            if(!this.sender){
                this.$message(this.msg('报关发件人不能为空'));
                return;
            }
            if(!this.checi){
                this.$message(this.msg('报关车次不能为空'));
                return;
            }

            var _this = this;

            this.$axios.post(this.$kit.api.declare.getCheci, "checi="+this.checi, {headers:{'Content-Type':'application/x-www-form-urlencoded'}})
                .then((result) => {
                    if(result.status){
                        _this.doSubmit();
                    }else{
                        this.$confirm('该车次不存在，是否添加新车次？', '提示', {
                            confirmButtonText: '是',
                            cancelButtonText: '否',
                            type: 'warning'
                        }).then(() => {
                            _this.doSubmit();
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '取消操作'
                            });          
                        });
                    }
                });
        },
        doSubmit(){
            var _this = this;
            this.$axios.post(this.$kit.api.declare.lock, "ids="+this.ids+"&type="+this.type+"&sender="+this.sender+"&checi="+this.checi, {headers:{'Content-Type':'application/x-www-form-urlencoded'}})
                .then((result) => {
                    _this.$message(result.msg);
                    _this.$emit("close-dg", true);
                });
        }
    }

}
</script>

<style lang="scss" scoped>

</style>